import React from 'react'
import { Grid } from '@mui/material'
import { useSelector } from 'react-redux'

import { withStyles } from '@mui/styles'
import { style } from 'styles'
import { formatNumber } from 'core/lib'

function ProductGrid({ gotoProduct, product }) {
	const shop = useSelector(state => state.shop)

	return (<Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
		<div className="product grid" onClick={() => gotoProduct(product)}>
			<div className="pic">
				<img src={`${window.__endpoint}/images/products/m/${product.main_image ? product.main_image.image_id : 'missing'}.jpg`} alt={product.name} />
			</div>
			{product.html_title && product.html_title != '' && <div className="title" dangerouslySetInnerHTML={{
				__html: product.html_title
			}}></div>}
			<div className="description">{product.description}</div>
			<div className="price">
				{product.offer_active && <del>{formatNumber(product.item_price)} €</del>}
				{formatNumber(product.price)} €
			</div>
			{shop.profiles.ueby_item_quantity_check == 1 && <div className="availability">Disponibilità {product.quantity}</div>}
		</div>
	</Grid>)
}

export default withStyles(style)(ProductGrid)
